import React, { useMemo } from 'react';
import { connect } from 'react-redux';
import { Alert, Grid } from '@mui/material';
import { selectStagingPoints } from '../../../redux/selectors/staging';
import { updateStaging } from '../../../redux/actions/staging';

const ProcessingAlert = ({ loaded, filteredPoints }) => {
  if (!loaded) return null;
  const taggerRunning = useMemo(
    () => filteredPoints.every((p) => 'point_type' in p.confidences),
    filteredPoints
  );
  if (taggerRunning) return null;

  return (
    <Grid item xs={12}>
      <Alert severity="warning">
        Some confidence values are not yet available and will appear after our processing is
        complete.
      </Alert>
    </Grid>
  );
};

const mapStateToProps = (state, { buildingId }) => {
  const staging = selectStagingPoints(state, buildingId);
  return {
    loaded: staging.loaded,
    filteredPoints: staging.filteredPoints,
  };
};

const mapDispatchToProps = (dispatch, { buildingId }) => ({
  updateStagingUncaught: (equipId, data) => dispatch(updateStaging(buildingId, equipId, data)),
});

export default connect(mapStateToProps, mapDispatchToProps)(ProcessingAlert);
